import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useJobTitleFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();

  const jobTitleIncludedOptions = [
    { label: 'Current', value: 'current' },
    { label: 'Current and past', value: 'all' },
  ];

  const formSchema = Yup.object().shape({
    jobTitles: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
    jobTitlesIncluded: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }),
  });

  const onSearchChange = (currentValue) =>
    getFilterOptions({
      facet: 'job_titles',
      query: currentValue,
      sharedList,
      orderBy,
    })
      .then((res) => res.data)
      .catch(() => {
        toast('Failed to load job titles', {
          icon: 'danger',
          id: 'failed-to-load-job-titles',
        });
        return [];
      });

  const onSubmit = ({ jobTitles, jobTitlesIncluded }) => {
    const filters = { jobTitles };

    // Only include jobTitlesIncluded if there are job titles selected
    if (jobTitles && jobTitles.length > 0) {
      filters.jobTitlesIncluded = jobTitlesIncluded;
    }

    setFilters(filters);
  };

  return {
    formSchema,
    onSearchChange,
    onSubmit,
    jobTitleIncludedOptions,
  };
};
